/*
 * RAK-221 (G3): text limits of the annotation contract are zod `.max(n)` checks, and zod counts
 * a string's `length`, i.e. UTF-16 code units. The client measures and cuts the same way, so a
 * comment the counter accepts is never refused by the server. An emoji counts two.
 */

/** Length as the contract measures it: UTF-16 code units, like zod's `.max()`. */
export function utf16Length(text: string): number {
  return text.length;
}

/**
 * Cuts text to at most `max` UTF-16 code units. It never ends on the first half of a surrogate
 * pair, so the result stays valid text and may be one unit shorter than `max`.
 */
export function clipUtf16(text: string, max: number): string {
  if (text.length <= max) return text;
  const limit = Math.max(0, Math.floor(max));
  const last = text.charCodeAt(limit - 1);
  const cut = limit > 0 && last >= 0xd800 && last <= 0xdbff ? limit - 1 : limit;
  return text.slice(0, cut);
}
